import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';
import { sentry } from 'sentry';

import { DeadlineViolationReason } from '@core/interfaces/deadlines-violations-reasons';

import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';

const SEARCH_QUERY = gql`
  query deadlineViolationReasons($where: DeadlineViolationReasonWhereInput) {
    deadlineViolationReasons(
      where: $where
      orderBy: name_asc
      limit: 100
      offset: 0
    ){
      items {
        id
        name
      }
    }
  }
`;

@Component({
  selector: 'fc-deadline-violation-reason-input',
  templateUrl: './fc-deadline-violation-reason-input.component.html'
})
export class FcDeadlineViolationReasonInputComponent {
  @Input()
  public control: FormControl;

  @Input()
  public deadlineContractId: string = null;

  @Input()
  public displayText: string;

  constructor(
    private readonly apollo: Apollo,
    private readonly fuseTranslationLoaderService: FuseTranslationLoaderService
  ) {
    this.fuseTranslationLoaderService.loadJsonTranslations({ english, portuguese, spanish });
    this.search = this.search.bind(this);
    this.displayWith = this.displayWith.bind(this);
  }

  async search(searchTerm: string): Promise<DeadlineViolationReason[]> {
    return this.apollo
      .query({
        query: SEARCH_QUERY,
        variables: {
          where: {
            nameContains: searchTerm,
            deadlineContractIds: this.deadlineContractId ? [this.deadlineContractId] : null,
            archived: false
          }
        }
      })
      .toPromise()
      .then((result) => {
        const { items } = result.data['deadlineViolationReasons'];
        return items;
      })
      .catch((err) => {
        sentry.captureException(err);
        return [];
      });
  }

  public displayWith(value: DeadlineViolationReason): string {
    return value && value.name;
  }
}
